<template>
  <li>
    <div class="d-flex justify-content-between w-100 align-items-center">
      <template v-if="enabled">
        <b-link @click="openPage()">
          {{ translate ? $t(title) : title }}
        </b-link>
        <slot />
      </template>
      <template v-else>
        <span>{{ $t(title) }}</span>
        <b-badge
          variant="danger"
          size="3"
        >
          <span class="unsubscribe-text">{{ $t('page.not-subscriber') }}</span>
        </b-badge>
      </template>
    </div>
  </li>
</template>

<script>
import {
  BLink, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'FeatureRow',
  components: {
    BLink, BBadge,
  },
  props: {
    pageId: Number,
    enabled: {
      type: [Boolean, Number],
      default: false,
    },
    insta: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    translate: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async openPage() {
      if (this.insta) {
        await this.$store.dispatch('instagram/SET_ACCOUNT', this.pageId)
        await this.$store.commit('auth/SET_MODEL_TYPE', 'instagram')
      } else {
        await this.$store.dispatch('pages/SET_PAGE', this.pageId)
        await this.$store.commit('auth/SET_MODEL_TYPE', 'fb')
      }
      this.$router.push({ name: this.route })
    },
  },
}
</script>
